import { createBrowserRouter } from "react-router-dom";
import RouteNames from "./type";
import Nikon from "../pages/Home";
import NikonStep from "../pages/CreateClaim";

export const router = createBrowserRouter([
  {
    path: RouteNames.NIKON,
    element: <Nikon />,
  },
  {
    path: RouteNames.CREATE_CLAIM,
    element: <NikonStep />,
  },
]);
